import React from "react";
import "./Products.css";

export default function Product(props) {
  const { product, onAdd } = props;
  return (
    <div>
      <div className="products">
        <img class="productImage" src={product.image} alt={product.name} />
        <div className="snack">
          <button onClick={() => onAdd(product)} className="addCart">
            ADD TO CART
          </button>
          <br></br>
          <div className="describe">{product.name} </div>
          <br></br>
          <div className="price">Ugx. {product.price}</div>
        </div>
      </div>
      <div className="products">
        <img class="productImage" src={product.image} alt={product.name} />
        <div className="snack">
          <button onClick={() => onAdd(product)} className="addCart">
            ADD TO CART
          </button>
          <br></br>
          <div className="describe">{product.name} </div>
          <br></br>
          <div className="price">Ugx. {product.price}</div>
        </div>
      </div>
      <div className="products">
        <img class="productImage" src={product.image} alt={product.name} />
        <div className="snack">
          <button onClick={() => onAdd(product)} className="addCart">
            ADD TO CART
          </button>
          <br></br>
          <div className="describe">{product.name} </div>
          <br></br>
          <div className="price">Ugx. {product.price}</div>
        </div>
      </div>
    </div>
  );
}
